<template>
    <div class="auth-dialog__right-column position-relative text-left px-4 px-sm-6 px-md-10 py-4 py-sm-6 py-md-10 overflow-x-hidden h-100"> 



        <MobileHeaderBackground />




        <div class="auth-dialog__scrollable hide-scrollbar h-100 z-4 position-relative overflow-y-scroll overflow-x-hidden">


            <img :src="AppConfigs.staticImages.LOGO" class="auth-dialog__logo-image" v-if="!isMobileDevice" style="margin-bottom: 30px" />

            <AuthWelcomeMessage class="pb-7" v-if="isMobileDevice" />


            <SignInSignUpToggle>

                <template v-slot:on>
                    <SignIn />
                </template>
                <template v-slot:off>
                    <SignUp />
                </template>

            </SignInSignUpToggle>




        </div>
    </div>
</template>



<script setup lang="ts">

import { ref, provide } from 'vue';
import { isMobile } from '@/utils/utils';
import { AppConfigs } from "@/app.configs";
import SignIn from '@/components/Auth/Signin/SignIn.vue';
import SignUp from '@/components/Auth/Signup/SignUp.vue';
import MobileHeaderBackground from './MobileHeaderBackground.vue'
import AuthWelcomeMessage from '@/components/Auth/Common/Messeges/AuthWelcomeMessage.vue'
import SignInSignUpToggle from '@/components/Auth/AuthDialog/Elements/SignInSignUpToggle.vue';

let on = ref(true);
provide('on', on);

const isMobileDevice = isMobile();

</script>